import React from 'react'
import { SelectPicker } from 'rsuite';

const Select = ({ component, onChange }: any) => {
    const data = component.values.map(
        (item: any) => ({ label: item.name, value: item.value })
    );
    return (
        <SelectPicker 
            defaultValue={component.defVal} 
            cleanable={component.cleanable || false} 
            searchable={false} 
            data={data} 
            style={{ width: 224 }} 
            onChange={onChange}
            value={component.val}
        />
    )
}

export default Select
